import { render, staticRenderFns } from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc_pc.vue?vue&type=template&id=05a4fcec&scoped=true&"
import script from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc_pc.vue?vue&type=script&lang=js&"
export * from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc_pc.vue?vue&type=script&lang=js&"
import style0 from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc_pc.vue?vue&type=style&index=0&id=05a4fcec&scoped=true&lang=less&"
import style1 from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc_pc.vue?vue&type=style&index=1&id=05a4fcec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a4fcec",
  null
  
)

export default component.exports